module.exports = __webpack_public_path__ + "static/media/djangosoft.525127ab.png";